module.exports = __webpack_public_path__ + "static/media/teddy.353e0b38.jpg";